<script setup lang="ts"></script>

<template>
  <div class="mt-2 p-2 bg-white dark:bg-stone-800 rounded-lg transition-colors duration-150">
    <slot></slot>
  </div>
</template>

<style scoped></style>
